<template>
  <div>
    <h1>iFrame</h1>
    <p>Builds pages as an iframe</p>
    <router-link to="/home" tag="a">return home</router-link>
    <br>

    <div class="block">
      <h2>Environment</h2>
      <ul style="display: inline-block;">
        <li>
          <input v-model="environment" id="dev" type="radio" value="dev" name="dev">
          <label for="dev">DEV</label>
        </li>
        <li>
          <input v-model="environment" id="qa" type="radio" value="qa" name="qa" />
          <label for="qa">QA</label>
        </li>
        <li>
          <input v-model="environment" id="beta" type="radio" value="beta" name="beta" disabled class="disabled" />
          <label for="beta" class="disabled">BETA</label>
        </li>
        <li>
          <input v-model="environment" id="prod" type="radio" value="" name="prod" disabled class="disabled" />
          <label for="prod" class="disabled">PROD</label>
        </li>
      </ul>
    </div>

    <div class="block">
      <h2>Version</h2>
      <ul>
        <li>
          <input v-model="isSSOv2" id="ssov2" type="radio" value="true" name="ssov2">
          <label for="ssov2">SSOv2</label>
        </li>
        <li>
          <input v-model="isSSOv2" id="sso" type="radio" value="false" name="sso" />
          <label for="sso">SSO</label>
        </li>
      </ul>
    </div>

<div class="block">
  <h2>Application</h2>
  <ul>
    <li>
      <input v-model="isSwivelPay" id="swivelpay" type="radio" value="true" name="swivelpay">
      <label for="swivelpay">SwivelPay</label>
    </li>
    <li>
      <input v-model="isSwivelPay" id="blp" type="radio" value="false" name="blp" />
      <label for="blp">BLP</label>
    </li>
  </ul>
</div>

<div class="block">
  <h2>Use Old Cert</h2>
  <ul>
    <li>
      <input v-model="useOldCert" id="useold" type="radio" value="true" name="useold">
      <label for="useold">True</label>
    </li>
    <li>
      <input v-model="useOldCert" id="usenew" type="radio" value="false" name="usenew" />
      <label for="usenew">False</label>
    </li>
  </ul>
</div>

    <form @submit="formSubmit">
      <br>
      <textarea cols=120 rows=22 class="form-control" v-model="displayClaims"></textarea>
      <br>
      <button id="login">Login</button>
    </form>
  </div>
</template>

<script>
import config from '../config'

export default {
  name: 'iframe',
  props: {
    msg: String
  },
  data() {
    return {
      claim: {},
      environment: 'dev',
      isSSOv2: true,
      isSwivelPay: true,
      useOldCert: false,
    };
  },
  created(){
    this.claim = {
      "service_provider_url": `https://api.${this.environment}baconpay.com/user/sso/saml/7f781661-c5ff-4682-b048-0163dd9f7cb3`,
      "claims": [
        {
          "key": "user_id",
          "value": "1515",
          "encoding": "string"
        },
        {
          "key": "fi_id",
          "value": "4078",
          "encoding": "string"
        },
        {
          "key": "xml_data",
          "value": "<userInfo><FullName>Robert Avani</FullName><email>15152@fi.com</email><homePhoneNumber>(307)640-1846</homePhoneNumber></userInfo>",
          "encoding": "base64"
        }
      ]
    }
  },
  watch: {
    environment(newVal) {
      this.claim.service_provider_url = `https://api.${newVal}baconpay.com/user/sso/saml/${this.isSSOv2 ? '7f781661-c5ff-4682-b048-0163dd9f7cb3' : ''}`;
    },
    isSSOv2(newVal) {
      // set url
      let institution = newVal === 'true' ? '7f781661-c5ff-4682-b048-0163dd9f7cb3' : '';
      this.claim.service_provider_url = `https://api.${this.environment}baconpay.com/user/sso/saml/${institution}`;

      //set encoding
      this.claim.claims[2].encoding = newVal === 'true' ? 'base64' : 'string'
    },
    useOldCert(newVal) {
      this.claim = {
        ...this.claim,
        "is_old_cert": newVal === 'true' ? 'true' : 'false'
      }
    }
  },
  computed: {
    displayClaims: {
      set: function(claim){
        this.claim = JSON.parse(claim)
      },
      get: function(){
        return JSON.stringify(this.claim, null, 2);
      }
    }
  },
  methods: {
    async formSubmit(e) {
      console.log(this.displayClaims);
      e.preventDefault();
      let currentObj = this;
      var options = {
        method: 'post',
        url: `${config.apiBaseUrl}/login`,
        data: JSON.parse(this.displayClaims),
        headers: {
          'Content-Type': 'application/json',
        }
      }

      await this.axios(options).then((response) => {
        var id = 'idp-iframe';

        if (document.getElementById(id)) {
          console.log(`ERROR: ${this.isSwivelPay ? 'Swivel Pay' : 'Bacon Web'} Client may not be opened more than once.`);
          return false;
        }

        var iframe = document.createElement('iframe');
        iframe.setAttribute('id', id)
        iframe.setAttribute('style', 'border: none; display: block; position: fixed; top: 0; left: 0; min-width: 100%; min-height: 100vh; max-height: 100%; z-index: 9999;')
        iframe.setAttribute('allowtransparency', 'true')
        this.isSwivelPay ? iframe.setAttribute('allow', 'payment') : iframe.setAttribute('scrolling', 'no')
        iframe.src = 'data:text/html;charset=utf-8,' + encodeURI(response.data);
        console.log("iframe", iframe);
        document.body.appendChild(iframe);


        var closeListener = function (event) {
          if (typeof window.removeEventListener !== 'undefined' && event.data === 'closeIframe') {
            var iframe = document.getElementById(id);
            iframe.parentNode.removeChild(iframe);
            window.removeEventListener('message', closeListener);
          }
        };

        if (typeof window.addEventListener !== 'undefined') {
          window.addEventListener('message', closeListener);
        }
      })
      .catch(function (error) {
          currentObj.output = error;
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../styles/main.scss';
</style>
